import React from 'react';
import Icono from '../assets/img/Check_green.svg'

const TRXBoxDataMobile = ({ icon, row1Title, row2Amount }) => {
  return (
    <div className="trx-box-data-mobile">
      <div className="top-row">
        <img src={icon} />
        <div className="title">{row1Title}</div>
      </div>
      <div className="separator-trx-card"></div>
      <div className="bottom-row">
        <div className="amount">{row2Amount}</div>
      </div>
    </div>
  );
}

export default TRXBoxDataMobile